module.exports = __webpack_public_path__ + "img/p-4.91156c36.jpg";